import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

import { AppConfiguration } from '../../app.configuration';
import { LoadingSpinnerModule } from '../loading-spinner/loading-spinner..module';

import { RegisterComponent } from './register.component';

@NgModule({
  declarations: [
    RegisterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerModule,
    RecaptchaV3Module
  ],
  exports: [
    RegisterComponent
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useFactory: (appConfiguration: AppConfiguration) => appConfiguration.recaptchaSiteKey,
      deps: [AppConfiguration]
    }
  ]
})
export class RegisterModule { }
